import confetti from "canvas-confetti";

export function celebrate(kind = "complete") {
  const base = {
    particleCount: 120,
    spread: 70,
    startVelocity: 45,
    ticks: 200,
    gravity: 0.9,
    scalar: 1,
    origin: { y: 0.6 },
  };
  const colors = ["#4ade80", "#ff3d8b", "#ffffff", "#a7f3d0"];
  if (kind === "complete") {
    confetti({ ...base, particleCount: 180, spread: 90, colors });
    setTimeout(() => confetti({ ...base, angle: 60, origin: { x: 0, y: 0.7 }, colors }), 200);
    setTimeout(() => confetti({ ...base, angle: 120, origin: { x: 1, y: 0.7 }, colors }), 400);
  } else if (kind === "timer") {
    confetti({ ...base, particleCount: 80, spread: 60, colors });
  } else if (kind === "streak") {
    confetti({ ...base, particleCount: 40, spread: 40, scalar: 0.7, colors });
  }
}

export function edgeFlash(color = "pink") {
  const el = document.createElement("div");
  el.className = `edge-flash edge-flash-${color}`;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 700);
}
